export default __webpack_public_path__ + "static/media/Ballroll_00275.a5456ba9.png";